import { getFunctions, httpsCallable } from "firebase/functions";

import { firebaseApp } from "./firebase";

export type CentralSystemNotification = {
  actionUrl: string | null;
  body: string;
  caseId: string | null;
  createdAt: string;
  emailStatus: string;
  id: string;
  read: boolean;
  title: string;
  type: "system";
};

const functions = getFunctions(firebaseApp, "us-east1");

export async function listCentralSystemNotifications() {
  const callable = httpsCallable<undefined, { notifications: CentralSystemNotification[] }>(
    functions,
    "listCentralSystemNotifications",
  );
  return (await callable(undefined)).data.notifications;
}

export async function markCentralSystemNotificationRead(notificationId: string) {
  const callable = httpsCallable<{ notificationId: string }, { notificationId: string; read: true }>(
    functions,
    "markCentralSystemNotificationRead",
  );
  return (await callable({ notificationId })).data;
}

export async function markAllCentralSystemNotificationsRead() {
  const callable = httpsCallable<undefined, { markedRead: number }>(
    functions,
    "markAllCentralSystemNotificationsRead",
  );
  return (await callable(undefined)).data;
}

export function getSystemNotificationErrorMessage(error: unknown) {
  const code = typeof error === "object" && error && "code" in error ? String(error.code) : "";
  if (code.includes("unauthenticated")) return "Sign in again to refresh notifications.";
  if (code.includes("permission-denied")) return "Your account cannot open this notification inbox.";
  return "Notifications could not be refreshed. Try again.";
}
